import StatCard from "pages/dashboard-overview/components/StatCard";

const formatCurrency = (value) =>
  `$${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export default function CommissionsKpiCards({ totalOwed = 0, totalPaid = 0, isLoading = false }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
      <StatCard
        title="Total Commissions Owed (This Month)"
        value={formatCurrency(totalOwed)}
        icon="Clock"
        isLoading={isLoading}
      />
      <StatCard
        title="Total Commissions Paid (This Month)"
        value={formatCurrency(totalPaid)}
        icon="CheckCircle"
        isLoading={isLoading}
      />
    </div>
  );
}
